import { IStoreState } from 'modules/types';

export const getEventDetail = (state: IStoreState) => state.eventDetail.eventData